import $ from 'jquery';
$(document).ready(function () {
    //if cookie hasn't been set...
    if (document.cookie.indexOf("ModalShown=true")<0 && wp_environment.show_alerts > 0) {
        $('#ume-info-modal').modal("show");

       umeCreateCookie('ModalShown', 'true', 1 );
    }
});


function umeCreateCookie(name, value, days){
    let expires = '';
    if(days){
        let d = new Date();
        d.setTime(d.getTime()+(days*24*60*60*1000));
        expires ='; expires='+d.toGMTString();
    }
    document.cookie = name+'='+value+expires+'; path=/';
}